<h4 class="ms-3 mt-3">Ladestationen zur Steuerung auswählen</h4>
<div class="scrollable-list">
    <ul class="list-group">
        <li class="list-group-item" *ngFor="let station of chargingStationDtos">
            <input
              style="cursor: pointer;"
              class="form-check-input me-1"
              type="checkbox"
              [id]="station.id"
              [checked]="isStationSelected(station)"
              (change)="toggleSelection(station, $event.target.checked)"
            />
            <label
              style="cursor: pointer;"
              class="form-check-label"
              [for]="station.id"
            >
              {{ station.name }} ({{ station.location }})
            </label>
          </li>
          
    </ul>
</div>
<div class="d-flex justify-content-end mt-3 mb-3" style="margin-left: auto;">
    <button class="btn btn-yellow me-2" id="create_deliverynote1" i18n="@@CreateDeliveryNoteButton"
        style="white-space: nowrap; min-width: 0;" (click)="saveSelection()">
        <span>&nbsp;Auswahl übernehmen</span>
    </button>

    <button class="btn btn-yellow me-3" id="create_deliverynote2" i18n="@@CreateDeliveryNoteButton"
        style="white-space: nowrap; min-width: 0;" (click)="closeDialog()">
        <span>&nbsp;Abbrechen</span>
    </button>
</div>